const messages = {
	edit: {
		id: 'eoc.heartbeats.table-actions.edit.no-translate',
		defaultMessage: 'Edit',
		description: 'Text of edit action button applied on a heartbeat.',
	},
	duplicate: {
		id: 'eoc.heartbeats.table-actions.duplicate.no-translate',
		defaultMessage: 'Duplicate',
		description: 'Text of duplicate action button applied on a heartbeat.',
	},
	turnon: {
		id: 'eoc.heartbeats.table-actions.turnon.no-translate',
		defaultMessage: 'Turn on',
		description: 'Text of turn-on action button applied on a heartbeat.',
	},
	turnoff: {
		id: 'eoc.heartbeats.table-actions.turnoff.no-translate',
		defaultMessage: 'Turn off',
		description: 'Text of turn-off action button applied on a heartbeat.',
	},
	delete: {
		id: 'eoc.heartbeats.table-actions.delete.no-translate',
		defaultMessage: 'Delete',
		description: 'Text of delete action button applied on a heartbeat.',
	},
	copy: {
		id: `eoc.heartbeats.table-actions.copy.no-translate`,
		defaultMessage: 'Copy heartbeat name',
		description: "The text will be displayed at the copy button's tooltip",
	},
	copySuccess: {
		id: `eoc.heartbeats.table-actions.copySuccess.no-translate`,
		defaultMessage: 'Heartbeat name copied sucessfully!',
		description: "The text will be displayed at the copy button's tooltip",
	},
	moreAriaLabel: {
		id: `eoc.heartbeats.table-actions.moreAriaLabel.no-translate`,
		defaultMessage: 'More actions for {name}',
		description: 'The aria label of more button',
	},
};

export default messages;
